<template>
  <div>
    <app-head></app-head>
    <app-body>
      <div>
        <div class="news-background">
          <div class="banner-content-white-text">
            <div style="display: flex; gap: 300px; justify-content: center;">
              <el-card class="news-center-card" shadow="hover" style="color: white">
                <div class="news-center-content">
                  <h1 style="font-family: STCaiyun, Arial, sans-serif;" class="main-title">新闻中心</h1>
                  <hr>
                  <h2 class="sub-title">NEWS CENTER</h2>
                </div>
                <el-menu
                    :default-active="activeIndex"
                    mode="horizontal"
                    @select="handleSelect"
                    class="news-tabs"
                    style="display: flex; justify-content: center;"
                    background-color="transparent"
                    text-color="#fff"
                    active-text-color="#409EFF"
                >
                  <el-menu-item index="0">公司资讯</el-menu-item>
                  <el-menu-item index="1">行业新闻</el-menu-item>
                  <el-menu-item index="2">通知公告</el-menu-item>
                </el-menu>
              </el-card>
            </div>
            <div class="breadcrumb-container">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                  <router-link to="/"><i class="el-icon-house"></i> 首页</router-link>
                </el-breadcrumb-item>
                <el-breadcrumb-item>新闻资讯</el-breadcrumb-item>
                <el-breadcrumb-item>{{ activeMenuText }}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
        </div>
        <div class="news-container">
          <div class="article-grid" v-if="mainArticles && mainArticles.length > 0">
            <div v-for="(article, index) in mainArticles" :key="index" class="article-card"
                 @click="toDetails(article.id)">
              <div class="article-image">
                <img class="article-hover-image" :src="$store.state.baseApi + article.image" alt="文章配图">
              </div>
              <div class="article-content">
                <h2 class="article-title">{{ article.title }}</h2>
                <p class="article-summary">{{ article.summary }}</p>
              </div>
            </div>
          </div>
          <div class="news-content" v-else>
            <span class="icon iconfont icon-zanwuneirongwudingdanwuneirong" style="font-size: 400px;"></span>
            <p style="font-size: 40px; font-weight: bold;">暂无内容</p>
          </div>
          <div class="latest-articles">
            <div v-for="(article, index) in latestArticles" :key="index" class="latest-article"
                 @click="toDetails(article.id)">
              <div class="date-box">
                <div class="date-day">{{ getDay(article.publishTime) }}</div>
                <div class="date-month">{{ getMonth(article.publishTime) }}</div>
              </div>
              <div class="article-info">
                <h3 class="article-title">{{ article.title }}</h3>
                <p class="article-summary">{{ article.summary }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-body>
    <app-foot></app-foot>
  </div>
</template>

<script>
import AppHead from '../common/AppHeader.vue';
import AppBody from '../common/AppPageBody.vue'
import AppFoot from '../common/AppFoot.vue'

export default {
  name: "index",
  components: {
    AppHead,
    AppBody,
    AppFoot
  },
  data() {
    return {
      hue: 90,
      hue1: 90,
      activeIndex: '0',
      activeMenuText: '公司资讯',
      animationFrameId: null,
      carouselImages: [
        {id: 1, url: require('@/assets/img/about-img-1.jpg'), alt: '第一张图片'},
        {id: 2, url: require('@/assets/img/about-img-2.jpg'), alt: '第二张图片'}
      ],
      carouselImages1: [
        {id: 1, url: require('@/assets/img/values-1.jpg'), alt: '第一张图片'},
        {id: 2, url: require('@/assets/img/values-2.jpg'), alt: '第二张图片'},
        {id: 3, url: require('@/assets/img/values-3.jpg'), alt: '第三张图片'},
        {id: 4, url: require('@/assets/img/values-4.jpg'), alt: '第四张图片'},
      ],
      mainArticles: [
        {
          id: 1,
          title: '企业培训到底是不是刚需？',
          summary: '目前我进入这个行业，就不断的听到大咖们讨论这个问题，企业培训到底是不是刚需？有人说是刚需，也有人说不是刚需，十几年来这个问题一直存在争议。',
          image: 'https://ai-public.mastergo.com/ai/img_res/3f4845a9a4fdad563085ab5f4c29eaf7.jpg',
          type: 1
        },
        {
          id: 2,
          title: '中高层管理人员的培训方法',
          summary: '企业的生存和发展，从一定意义上取决于中、高层管理人员的工作能力和管理水平。掌好这些人员的培训，是实现企业发展的重要保障。',
          image: 'https://ai-public.mastergo.com/ai/img_res/fdcd545d0a1e872bf4c0d3851cd76268.jpg',
          type: 2
        },
        {
          id: 3,
          title: '培训干货：教你互步规划企业培训',
          summary: '培训开发是一项系统性和复杂性程度都相对较高的工作，而做好该工作的前提和基础就是有效的培训计划，尤其是年度培训计划的制定。',
          image: 'https://ai-public.mastergo.com/ai/img_res/deb47588db2ccc88778eef967c81b06f.jpg',
          type: 3
        }
      ],
      latestArticles: [
        {
          id: 4,
          title: '培训开场和结尾这样玩，让你的培训事半功倍',
          summary: '在培训过程中，我们经常会遇到以下困惑："怎么才能激发学员的学习欲望？"、"如何才能更好与学员进行互动？"、"为什么学员总记不住我讲过的内容呢？"',
          date: {day: '01', month: '2018/02'},
          type: 1
        },
        {
          id: 5,
          title: '2018送给培训者的10个发展建议',
          summary: '一眨眼已经是2018年了，回顾过去的一年，高哥在培训经理指南上已经写了35万字，目测是培训界原创文字多的老师。回顾过去，展望未来，在写2018年的筹备篇文章时，有一句话我觉得写得特别好。',
          date: {day: '01', month: '2018/02'},
          type: 2
        }
      ]
    };
  },
  created() {
    this.handleSelect('0');
  },
  mounted() {

  },
  watch: {},
  methods: {
    handleSelect(index) {
      this.activeIndex = index;
      this.$api.getNewsListByType(
          {
            type: index,
          }
      ).then(res => {
        if (res.code !== 200) {
          this.$message.error(res.message);
        }
        //前三个为mainArticles,其余为latestArticles
        this.mainArticles = res.data.slice(0, 3);
        this.latestArticles = res.data.slice(3);
      })
      switch (index) {
        case '0':
          this.activeMenuText = '公司资讯';
          break;
        case '1':
          this.activeMenuText = '行业新闻';
          break;
        case '2':
          this.activeMenuText = '通知公告';
          break;
      }
    },
    toDetails(id) {
      this.$router.push({
        path: '/newsDetails',
        query: {
          id: id
        }
      });
    },
    getDay(publishTime) {
      if (!publishTime) return '';
      // 创建 Date 对象
      const date = new Date(publishTime);
      // 获取日期
      return date.getDate().toString().padStart(2, '0');
    },
    getMonth(publishTime) {
      if (!publishTime) return '';
      // 创建 Date 对象
      const date = new Date(publishTime);
      // 获取月份，注意月份从 0 开始，所以要加 1
      const month = date.getMonth() + 1;
      // 获取年份
      const year = date.getFullYear();
      return `${year}/${month.toString().padStart(2, '0')}`;
    },
  }
}
</script>

<style scoped>

.news-background {
  width: 100%;
  background-image: url("../../../assets/img/contact-bg.jpg");
  margin-top: -30px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  min-height: 500px
}

.banner-content-white-text {
  position: absolute;
  top: 40%;
  left: 50%;
  color: white;
  transform: translate(-50%, -50%);
  text-align: center;
}

/* 面包屑容器样式 */
.breadcrumb-container {
  position: absolute;
  left: 50%;
  margin-top: 138px;
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(255, 255, 255, 0.5); /* 半透明背景 */
  padding: 8px 16px;
  border-radius: 4px;
  width: 210px;
}

.banner-content-white-text h1 {
  font-size: 36px;
  margin-bottom: 20px;
}


.news-center-card {
  width: 800px;
  margin: 0 auto;
  text-align: center;
  border: none;
  background: transparent;
}

.main-title {
  font-size: 32px;
  margin-bottom: 10px;
  font-weight: bold;
}

.sub-title {
  font-size: 18px;
  color: #909399;
  font-weight: normal;
  letter-spacing: 2px;
  margin-top: 0;
}

.news-tabs {
  margin-top: 20px;
  border-bottom: none; /* 确保已有样式中 border-bottom 为 none */
  background: transparent;
}

/* 覆盖 Element UI 水平菜单的底部边框样式 */
.news-tabs.el-menu--horizontal {
  border-bottom: none !important;
}

.news-tabs .el-menu-item {
  font-size: 16px;
  padding: 10px 50px;
  color: white;
}

.news-tabs .el-menu-item.is-active {
  color: #409EFF !important;
  border-bottom: 2px solid #409EFF !important;
}

.news-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.article-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  padding: 48px 0;
}

.article-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
  overflow: hidden;
}

.article-card:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.article-image {
  height: 192px;
  overflow: hidden;
}

.article-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}

.article-content {
  padding: 24px;
}

.article-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
  cursor: pointer;
}

.article-title:hover {
  color: #2563eb;
}

.article-summary {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

.latest-articles {
  padding-bottom: 48px;
}

.latest-article {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  transition: box-shadow 0.3s ease;
}

.latest-article:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.date-box {
  flex-shrink: 0;
  margin-right: 24px;
  text-align: center;
}

.date-day {
  font-size: 32px;
  font-weight: bold;
  color: #d1d5db;
}

.date-month {
  font-size: 14px;
  color: #6b7280;
}

.article-info {
  flex-grow: 1;
}

.news-content {
  display: flex; /* 使用 Flexbox 布局 */
  flex-direction: column; /* 子元素垂直排列 */
  align-items: center; /* 子元素在交叉轴（水平方向）上居中 */
  justify-content: center; /* 子元素在主轴（垂直方向）上居中 */
  min-height: 300px; /* 设置最小高度，确保内容有足够空间显示 */
  text-align: center; /* 文本居中 */
  color: rgb(181 181 181);
}

.news-content .icon {
  display: block; /* 将图标设置为块级元素 */
  margin-bottom: 16px; /* 图标与文本之间添加间距 */
  margin-top: 50px;
}

.article-hover-image {
  transition: transform 0.3s ease; /* 添加过渡效果 */
  transform-origin: center; /* 设置变换原点为中心 */
}

.article-hover-image:hover {
  transform: scale(1.1); /* 鼠标悬停时图片放大 5% */
}

</style>